import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { Router } from '@angular/router';

interface MarketingTip {
  id: number;
  title: string;
  description: string;
  icon: string;
  examples: string[];
  expanded: boolean;
}

@Component({
  selector: 'app-tips',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent],
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.css'],
})
export class TipsComponent {
  constructor(private router: Router) {}

  tips: MarketingTip[] = [
    {
      id: 1,
      title: 'Create an Eye-Catching Title',
      description:
        'Your title is the first thing potential buyers see. Make it descriptive, specific, and include key details that buyers search for.',
      icon: '✏️',
      examples: [
        'Instead of "Blue Dress", try "Elegant Royal Blue Midi Dress with Pockets, Size M"',
        'Instead of "Guitar", try "Fender Stratocaster Electric Guitar - Sunburst Finish, Maple Neck"',
        'Instead of "Chair", try "Mid-Century Modern Accent Chair - Teal Velvet with Walnut Legs"',
      ],
      expanded: false,
    },
    {
      id: 2,
      title: 'Write Detailed Descriptions',
      description:
        'Provide comprehensive information about your item, including condition, measurements, materials, and any defects.',
      icon: '📝',
      examples: [
        'Mention exact dimensions, materials, and care instructions',
        'Describe the condition honestly - note any flaws or wear',
        "Share the item's history or story if relevant and interesting",
      ],
      expanded: false,
    },
    {
      id: 3,
      title: 'Use High-Quality Photos',
      description:
        "Clear, well-lit photos from multiple angles help buyers see exactly what they're getting.",
      icon: '📸',
      examples: [
        'Take photos in natural light against a clean background',
        'Include close-ups of details, labels, and any flaws',
        'Show the item being used/worn when appropriate',
      ],
      expanded: false,
    },
    {
      id: 4,
      title: 'Set the Right Price',
      description:
        'Research similar listings to find the sweet spot for pricing your item competitively.',
      icon: '💰',
      examples: [
        'Search for similar sold items to gauge market value',
        'Consider condition, brand, and rarity when pricing',
        'Set a slightly lower price if you want to sell more quickly',
      ],
      expanded: false,
    },
    {
      id: 5,
      title: 'Choose Relevant Categories & Tags',
      description:
        'Proper categorization ensures your listing appears in the right searches.',
      icon: '🏷️',
      examples: ['Select the most specific category that applies to your item'],
      expanded: false,
    },
    {
      id: 6,
      title: 'Respond Quickly to Inquiries',
      description:
        'Fast, friendly responses improve your chances of making a sale and build your reputation.',
      icon: '💬',
      examples: [
        'Answer questions thoroughly and politely',
        'Be upfront about shipping times and policies',
      ],
      expanded: false,
    },
  ];

  toggleExpand(tipId: number) {
    this.tips = this.tips.map((tip) => {
      if (tip.id === tipId) {
        return { ...tip, expanded: !tip.expanded };
      } else {
        return { ...tip, expanded: false };
      }
    });
  }

  goToSell(): void {
    this.router.navigate(['/sell']);
  }
}
